<script lang="ts">
  import CheckboxChecked from "../../../icons/CheckboxCheckedV3.svg"

  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"

  import { recommendation } from "../../../stores/recommendation"

  import Button from "../../Common/Button.svelte"

  export let product: RecommendationProduct

  function handleSelectButtonClick () {
    if (product.selected) {
      recommendation.unselectProduct(product.id)
    } else {
      recommendation.selectProduct(product.id)
    }
  }
</script>

<Button
  icon={CheckboxChecked}
  active={product.selected}
  class="add-to-cart-button"
  on:click={handleSelectButtonClick}
  >
  {
    product.selected
      ? `Added to Cart`
      : `Add to cart`
  }
</Button>
